import "bootstrap/dist/css/bootstrap.min.css"
import "./style.scss"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./components/layout/layout";
import { LoginPage } from "./components/loginpage/loginpage";
import Signup from "./components/login/Signup";
import { PasswordPage } from "./components/passwordpage/PasswordPage";
import { Products } from "./components/Products/Products";
import ResetPassword from "./components/login/ResetPassword";


function App() {

  return (
    <Router>
      <Routes>
        <Route exact path="*" element={<Layout />}></Route>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgotpassword" element={<PasswordPage />} />
        <Route path="/products" element={<Products />} />
        <Route path="/SetNewPassword" element={<ResetPassword />} />
      </Routes>
    </Router>
  )
}

export default App;
